import { http as api } from '@/app/lib/http/client'

export interface FacturamaCatalogItem {
  Value: string
  Name: string
}

export const CFDI_CANCEL_MOTIVES = [
  { value: '01', label: '01 – Comprobante emitido con errores con relación (requiere UUID de sustitución)' },
  { value: '02', label: '02 – Comprobante emitido con errores sin relación' },
  { value: '03', label: '03 – No se llevó a cabo la operación' },
  { value: '04', label: '04 – Operación nominativa relacionada en una factura global' },
] as const

export type CfdiCancelMotive = '01' | '02' | '03' | '04'

export const facturamaService = {
  searchCatalogs: async (catalog: string, keyword: string): Promise<FacturamaCatalogItem[]> => {
    const { data } = await api.get<{ data: FacturamaCatalogItem[] }>(`/integrations/facturama/catalogs/${catalog}`, {
      params: { keyword },
    })
    return data.data
  },
  createGlobalInvoice: async (saleIds: Array<string | number>, periodicity: string, months: string, year: string): Promise<any> => {
    const { data } = await api.post<{ data: { cfdi: any } }>(`/integrations/facturama/global-invoice`, {
      sale_ids: saleIds,
      periodicity,
      months,
      year,
    })
    return data.data.cfdi
  },
  downloadInvoicePdf: async (cfdiId: string): Promise<string> => {
    const { data } = await api.get<{ data: { pdf_base64: string } }>(`/integrations/facturama/invoices/${cfdiId}/pdf`)
    return data.data.pdf_base64
  },
  downloadInvoiceXml: async (cfdiId: string): Promise<string> => {
    const { data } = await api.get<{ data: { xml_base64: string } }>(`/integrations/facturama/invoices/${cfdiId}/xml`)
    return data.data.xml_base64
  },
  getInvoices: async (params?: Record<string, any>): Promise<any[]> => {
    const { data } = await api.get<{ data: { invoices: any[] } }>(`/integrations/facturama/invoices`, {
      params,
    })
    return data.data.invoices
  },
  getProfile: async (): Promise<any> => {
    const { data } = await api.get<{ data: any }>(`/integrations/facturama/profile`)
    return data.data
  },
  /**
   * Cancela un CFDI ante el SAT a través de Facturama.
   * @param cfdiId - ID del CFDI en Facturama.
   * @param motive - Motivo de cancelación SAT (01-04).
   * @param uuidReplacement - UUID del CFDI sustituto (solo motivo 01).
   * @param saleId - ID local de la venta para actualizar cfdi_cancelled_at.
   */
  cancelInvoice: async (
    cfdiId: string,
    motive: CfdiCancelMotive,
    uuidReplacement?: string,
    saleId?: number | string,
  ): Promise<void> => {
    await api.delete(`/integrations/facturama/invoices/${cfdiId}`, {
      data: {
        cfdiId,
        motive,
        uuid_replacement: uuidReplacement || undefined,
        sale_id: saleId || undefined,
      },
    })
  },
}
